module.exports = __webpack_public_path__ + "img/send-msg.ca78a401.svg";